import React, { Fragment, useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as TerminalBetslipActions from 'actions/TerminalBetslipActions';
import * as BetslipActions from 'actions/BetslipActions';
import * as UiActions from 'actions/UiActions';
import 'css/ViewMainMarkets.scss';
import { EVENT_STATUS, MARKET_STATUS } from 'constants/appConfig';
import { UI_ERROR_MESSAGE } from 'constants/ui';
import tapOrClick from 'utils/click-or-touch';
import { OUMarketButtonStyled as Button } from '../styled';
import { isTerminal } from 'utils/UiHelper';
import { MarketButtonsRow } from '../styled';
import { useContainerWidth } from '../../../contexts/ContainerWidthContext';
import { Col } from '../../../styled';

const ViewOUButtons = (props) => {
    const { ev, market } = props;
    const contentWidth = useContainerWidth();
    const [betLabels, setBetLabels] = useState({
        '0': '-',
        '1': '-',
    });

    const addMarket = (item) => {
        if (
            props.betslip.betList.filter((bet) => bet.eventId === ev.eventId)
                .length === 0 &&
            props.betslip.customBetEventId === null &&
            props.betslip.placedCustomBetMarkets.length === 0
        ) {
            const isLive = ev.live ? '1' : '0';

            if (!isTerminal()) {
                props.betslipActions.addMarket(
                    market.marketId,
                    item.betNr,
                    item.odds,
                    isLive,
                    market.sportId,
                    props.betslip.hasMarkets
                );
            } else {
                props.terminalBetslipActions.addMarket(
                    props.betslip,
                    market.eventId,
                    ev.eventName,
                    market.marketId,
                    item.betNr,
                    0,
                    item.odds,
                    item.bet,
                    market.marketName,
                    isLive,
                    ev
                );
            }
        } else {
            props.uiActions.notification(
                UI_ERROR_MESSAGE,
                'Komibinationen er ikke tilladt'
            );
        }
    };

    const removeMarket = (marketId) => {
        if (isTerminal()) {
            props.terminalBetslipActions.removeMarket(marketId);
            return;
        }
        if (props.betslip?.betList?.length > 1) {
            props.betslipActions.clearSystemMarket(market.eventId, marketId);
            return;
        }
        props.betslipActions.clearSingleMarket(market.eventId, marketId);
    };

    const isActive = (btnItem) => {
        if (
            props.betslip.placedCustomBetMarkets.length === 0 &&
            props.betslip.customBetEventId === null
        ) {
            return props.betslip.betList.some(
                (item) =>
                    item.gameId === market.marketId &&
                    item.betText === btnItem.bet &&
                    item.marketName === market.marketName &&
                    item.betNr === btnItem.betNr
            );
        }
    };

    const getBetLabel = (marketItem) => {
        const [overItem] = market.itemList;
        return `${overItem === marketItem ? 'O' : 'U'} ${market.extraInfo}`;
    };

    const renderButtonByMarketItemIndex = (index) => {
        const marketItem = market && market.itemList && market.itemList[index];
        const isDisabled =
            (ev && ev.status) !== EVENT_STATUS.IN_PROGRESS ||
            (market && market.status) !== MARKET_STATUS.ACTIVE ||
            marketItem?.odds <= 1;
        const label = betLabels[index];
        const value = marketItem?.odds?.toFixed(2) || '-';

        const content =
            !marketItem && label === '-' ? (
                <span className="noOdds">-</span>
            ) : (
                <>
                    <div className="bet-label">{label}</div>
                    <div className="bet-value">{value}</div>
                </>
            );

        if (!marketItem || isDisabled) {
            return (
                <Button disabled $contentWidth={contentWidth}>
                    {content}
                </Button>
            );
        }

        return (
            <Button
                active={isActive(marketItem)}
                disabled={isDisabled}
                oddsYellow
                {...tapOrClick(
                    isActive(marketItem)
                        ? removeMarket.bind(this, market.marketId)
                        : addMarket.bind(this, marketItem)
                )}
                $contentWidth={contentWidth}
            >
                {content}
            </Button>
        );
    };

    useEffect(
        () => {
            if (market?.itemList) {
                const newLabels = {};
                Object.entries(market.itemList).forEach(([key, item]) => {
                    newLabels[key] = getBetLabel(item);
                });
                setBetLabels(newLabels);
            }
        },
        [market?.itemList]
    );

    return (
        <MarketButtonsRow>
            <Col>{renderButtonByMarketItemIndex(0)}</Col>
            <Col>{renderButtonByMarketItemIndex(1)}</Col>
        </MarketButtonsRow>
    );
};

function mapStateToProps(state) {
    return { betslip: state.betslip };
}

function mapDispatchToProps(dispatch) {
    return {
        terminalBetslipActions: bindActionCreators(
            TerminalBetslipActions,
            dispatch
        ),
        betslipActions: bindActionCreators(BetslipActions, dispatch),
        uiActions: bindActionCreators(UiActions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewOUButtons);
